import { render, staticRenderFns } from "./ReportProvince.vue?vue&type=template&id=8923e8ae"
import script from "./ReportProvince.vue?vue&type=script&lang=js"
export * from "./ReportProvince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports